import React from 'react'
import AlertMessagge from '../../../components/molecules/alertMessagge/alertMessagge'
import Button from '../../../shared/components/atoms/Button/Button'
import LogoIcon from '../../../shared/assets/images/nuevo-logo-tena.svg'
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import { pushGtagEvent } from '../../../shared/utils/metricManagementUtil'
import { convertText } from '../../../shared/utils/convertFirstCharacterToUppercase'
import './modalAlert.scss'

const ModalAlert = ({ hideAction, actionAlert }) => {
	const userInfo = dataLayerUserInfo()

	let samples = []
	const gtag = {
		event: 'begin_checkout',
		params: {
			flow_type: 'muestra gratis',
			items: [],
			value: 0,
			user_data: userInfo.user_data ? userInfo.user_data : '',
			log_status: userInfo.log_status,
		},
	}

	React.useEffect(() => {
		samples = JSON.parse(localStorage.getItem('samples'))
		samples.forEach(sample => {
			gtag.params.items.push({
				item_id: sample.id,
				item_name: sample.name,
				discount: 0,
				affiliation: 'Tena Online',
				item_brand: 'Tena',
				item_category: sample.categoria,
				item_variant: sample.variant,
				price: 0,
				currency: process.env.LOCALE,
				quantity: 1,
				drip_degree: sample.drip_degree,
			})
		})
	}, [])

	return (
		<LayoutModal onClose={hideAction}>
			<div className='f-alert-wrapper'>
				<div className='f-card-modal-head'>
					<span className='f-card-modal-head-icon' onClick={hideAction}>
						X
					</span>
				</div>
				<AlertMessagge
					icon={<img src={LogoIcon} alt='sample-icon' />}
					messagge='¡Tu solicitud está completa!'
					description='No puedes agregar más productos.'
					type='primary'
					button={
						<Button
							type='button'
							text={convertText('SOLICITAR MI MUESTRA')}
							onClickAction={() => {
								pushGtagEvent(gtag)
								hideAction()
								actionAlert()
							}}
							classname='f-button f-button--primary'
						/>
					}
				/>
			</div>
		</LayoutModal>
	)
}

export default ModalAlert
